// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3358cfa8","239":"deeec03d","455":"43e3e5e2"}[chunkId] + ".chunk.js";
};